<template>
  <div id="excel-reporte-final-supervision">
    <custom-button
      label="Reporte Supervision"
      iconText="fa-file-excel"
      tipo="agregar"
      class="mr-2"
      :loading="estaCargando"
      @click="excelReporteSupervision">
    </custom-button>
  </div>
</template>

<script>

import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
import CustomButton from '@/components/buttons/Button.vue';
import mixExcelReporteSupervision from '@/components/exportar/exceles/mixExcelReporteSupervision';

const filaTitulos = 25;
const filaFotografias = 25;
const filasXFoto = 8;
const columnasXFoto = 4;

export default {
  name: 'ExcelReporteSupervision',
  props: {
    fecha: {
      type: String,
      required: false,
      default: '',
    },
  },
  mixins: [mixGenerarExceles, mixFormatoEstructura, mixExcelReporteSupervision],
  components: {
    CustomButton,
  },
  data() {
    return {
      reportesFisicosFotos: [],
      filaTerminaFotografias: 50,
      datos: [{ foto: '-' }],
      estaCargando: false,
      celdas: [
        {
          type: 'string',
          style: 'estilostring',
        },
      ],
      headers: [
        {
          value: 'foto',
          nombreColumna: 'foto',
          // col: 1,
          combinar: { row: filaTitulos, col: 1 },
        },
      ],

      logoDocumento: [
        {
          // logo en microservicio Excel
          path: 'public/img/logos/logo_HAyuntamiento.png',
          type: 'picture',
          position: {
            type: 'twoCellAnchor',
            from: {
              col: 1, colOff: 0, row: 2, rowOff: 0,
            },
            to: {
              col: 4, colOff: 0, row: 5, rowOff: 0,
            },
          },
        },
      ],
    };
  },

  methods: {
    // Genera el excel del reporte
    async excelReporteSupervision() {
      this.estaCargando = true;
      const data = await this.creaExcelReporteSupervision();
      await this.mixGenerarExcel(data);
      this.estaCargando = false;
    },

    // Formato y posicion a las fotos que contiene el reporte
    async getImagenesReporte() {
      const fotos = [];
      let fila = filaFotografias;
      let columna = 1;
      let numeroFoto = 1;
      if (!this.getContratoFotos) return [];
      this.reportesFisicosFotos = await this.getContratoFotos();
      if (!Array.isArray(this.reportesFisicosFotos)) return [];
      this.reportesFisicosFotos.map((i) => {
        fotos.push(
          {
            path: `${i.name}`,
            type: 'picture',
            extension: `${i.extension}`,
            position: {
              type: 'twoCellAnchor',
              from: {
                col: columna, colOff: 0, row: fila, rowOff: 0,
              },
              to: {
                col: columna + columnasXFoto, colOff: 0, row: fila + filasXFoto, rowOff: 0,
              },
            },
          },
        );
        columna += columnasXFoto;
        if (numeroFoto === 4) {
          fila = filaFotografias + filasXFoto;
          columna = 1;
          numeroFoto = 1;
        }
        numeroFoto += 1;

        return true;
      });

      this.filaTerminaFotografias = filaFotografias + (Math
        .ceil(((fotos.length + 1) / 4)) * filasXFoto) + 2;
      return fotos;
    },

    // Formato a todo el reporte con datos que se enviaran para generar el excel
    async creaExcelReporteSupervision() {
      const excelReporteSupervision = [...this.datos];
      const fotos = await this.getFotos;
      const datosDocumento = await this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombresColumnas = this.getColumnas;

      const data = {
        excelData: {
          configuration: {},
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas: [...nombresColumnas],
            filaInicio: filaTitulos + 1,
            data: [...excelReporteSupervision],
            fotos,
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>
</style>
